import { Controller } from "@hotwired/stimulus"

// Stimulus controller for review status indicator
// Handles real-time updates via Turbo Streams
export default class extends Controller {
  static values = { responseId: Number }

  connect() {
    console.log("Review status controller connected for response", this.responseIdValue)
  }

  // Called when status updates via Turbo Stream
  update(status, reviewedAt) {
    console.log("Review status updated:", status, reviewedAt)
    // Turbo Streams will handle the DOM updates
    // This is here for any additional JS logic if needed
  }

  // Animate status change
  animateChange() {
    this.element.classList.add('animate-pulse')
    setTimeout(() => {
      this.element.classList.remove('animate-pulse')
    }, 1000)
  }
}
